export function isKorOnly(value) {
  return (/^[가-힣]+$/).test(value);
}

export function isNumOnly(value) {
  return (/^[0-9]+$/).test(value);
}

export function isEngOnly(value) {
  return (/^[a-zA-Z]+$/).test(value);
}

export function isEngNumOnly(value) {
  return (/^[0-9a-zA-Z]+$/).test(value);
}

export function isJumin(value) {
  const temp = value.replace(/[^0-9]/g, '').match(/[0-9]{2}[01]{1}[0-9]{1}[0123]{1}[0-9]{1}[1234]{1}[0-9]{6}$/);
  if(!temp) return false;

  let birthYY = ((temp[6] * 1) == (1 || 2)) ? "19" : "20";
  birthYY += temp.substr(0, 2);
  const birthMM = temp.substr(2, 2) - 1;
  const birthDD = temp.substr(4, 2);
  const birthDay = new Date(birthYY, birthMM, birthDD);
  if (birthDay.getYear() % 100 != temp.substr(0, 2) || birthDay.getMonth() != birthMM || birthDay.getDate() != birthDD) {
      return false;
  }

  let sum = 0;
  const num = [2, 3, 4, 5, 6, 7, 8, 9, 2, 3, 4, 5];
  const last = (temp[12] * 1);
  for (var i = 0; i < 12; sum += temp[i] * num[i++]);
  return ((11 - sum % 11) % 10 == last);
}

export function isForeign(value) {
  const temp = value.replace(/[^0-9]/g, '').match(/[0-9]{2}[01]{1}[0-9]{1}[0123]{1}[0-9]{1}[1234]{1}[0-9]{6}$/);
  if(!temp) return false;

  let birthYY = ((temp[6] * 1) == (5 || 6)) ? "19" : "20";
  birthYY += temp.substr(0, 2);
  const birthMM = temp.substr(2, 2) - 1;
  const birthDD = temp.substr(4, 2);
  const birthDay = new Date(birthYY, birthMM, birthDD);
  if (birthDay.getYear() % 100 != temp.substr(0, 2) || birthDay.getMonth() != birthMM || birthDay.getDate() != birthDD) {
      return false;
  }

  if ((temp[7] * 10 + temp[8] * 1) % 2 != 0) return false;

  let sum = 0;
  const num = [2, 3, 4, 5, 6, 7, 8, 9, 2, 3, 4, 5];
  const last = (temp[12] * 1);
  for (var i = 0; i < 12; sum += temp[i] * num[i++]);
  return (((11 - sum % 11) % 10) + 2 == last);
}

export function isBiznum(value) {
  const temp = value.replace(/[^0-9]/g, '').match(/[0-9]{3}[0-9]{2}[0-9]{5}$/);
  if(!temp) return false;

  let sum = (temp[0] * 1);
  const num = [0, 3, 7, 1, 3, 7, 1, 3];
  for (var i = 1; i < 8; sum += (temp[i] * num[i++]) % 10);
  sum += Math.floor(temp[8] * 5 / 10);
  sum += (temp[8] * 5) % 10 + (temp[9] * 1);
  return (sum % 10 == 0);
}

export function isCorpnum(value) {
  const temp = value.replace(/[^0-9]/g, '').match(/[0-9]{6}[0-9]{7}$/);
  if(!temp) return false;

  let sum = 0;
  const num = [1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2];
  const last = temp[12] * 1;
  for (var i = 0; i < 12; sum += temp[i] * num[i++]);
  return ((10 - sum % 10) % 10 == last);
}

export function isEmail(value) {
  return (/\w+([-+.]\w+)*[@#]\w+([-.]\w+)*\.[a-zA-Z]{2,4}$/).test(value.trim());
}

export function isTel(value) {
  const temp = value.replace(/[^0-9]/g, '');
  return /^(02|0[3-9]{1}[0-9]{1})[1-9]{1}[0-9]{2,3}[0-9]{4}$/.test(temp);
}

export function isMobile(value) {
  const temp = value.replace(/[^0-9]/g, '');
  return /01[016789][1-9]{1}[0-9]{2,3}[0-9]{4}$/.test(temp);
}
